export default [{
  path: '/guide',
  name: 'guide',
  component: () => import('@/views/gd-guide/index'),
}]
